import { useState } from "react";
import Modal from "../components/common/Modal";
import { SignupForm } from "../components/common/SignupForm";
import {
  AIAgentHeroSection,
  ProblemSection,
  FeaturesSection,
  HowItWorksSection,
  ComparisonSection,
  CustomizationSection,
  WhyNustartzSection,
  OutcomesSection,
  UseCasesSection,
  FAQSection,
  FinalCTA,
} from "../components/ai-agent";

export default function AIAgentPage() {
  const [isDemoOpen, setIsDemoOpen] = useState(false);
  return (
    <div>
      <AIAgentHeroSection onDemoClick={() => setIsDemoOpen(true)} />
      <ProblemSection />
      <FeaturesSection />
      <HowItWorksSection />
      <ComparisonSection />
      <CustomizationSection />
      <WhyNustartzSection />
      <OutcomesSection />
      <UseCasesSection />
      <FAQSection />
      <FinalCTA onDemoClick={() => setIsDemoOpen(true)} />
      <Modal isOpen={isDemoOpen} onClose={() => setIsDemoOpen(false)} title="Book a Free Demo">
        <SignupForm />
      </Modal>
    </div>
  );
}
